import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13fa0a8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "title",
  class: "form-label text-muted"
}, " ชื่อหนังสือคำสั่ง: ", -1))
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "pined",
  class: "form-label text-muted"
}, " ปักหมุด: ", -1))
const _hoisted_11 = { class: "form-check form-switch" }
const _hoisted_12 = {
  class: "form-check-label",
  for: "pined"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "committeeForm",
    backdrop: "static",
    onHide: _ctx.clearForm
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.submited && _ctx.errors.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " * กรุณาป้อนชื่อหนังสือคำสั่ง "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.title}]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.title) = $event)),
            placeholder: "กรุณาป้อนชื่อหนังสือคำสั่ง...",
            "aria-label": "title",
            autocomplete: "off",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, null, 34), [
            [
              _vModelText,
              _ctx.formData.title,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", {
            for: "file",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.file}])
          }, " ไฟล์เอกสาร: ", 2),
          (_ctx.submited && _ctx.errors.file)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " * กรุณาเลือกไฟล์เอกสาร "))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            ref: "fileDialog",
            type: "file",
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.file}]),
            disabled: _ctx.isLoading,
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fileChange && _ctx.fileChange(...args)))
          }, null, 42, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "pined",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.pined) = $event)),
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.formData.pined]
            ]),
            _createElementVNode("label", _hoisted_12, _toDisplayString((_ctx.formData.pined) ? 'ตรึงข้อมูลไว้ด้านบน' : 'ปกติ'), 1)
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-danger me-auto",
            disabled: _ctx.isLoading,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
          }, [
            _hoisted_14,
            _createTextVNode(" ลบ ")
          ], 8, _hoisted_13))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_16,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_15),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.isLoading,
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_18,
        _createTextVNode(" บันทึก ")
      ], 8, _hoisted_17)
    ]),
    _: 1
  }, 8, ["onHide"]))
}